<script setup lang="ts">
import type { IFaqSection } from '@/widgets/FaqSection/model/types/faqSection';
import Accordion from '@/shared/ui/Accordion/index';

defineProps<IFaqSection>();

const isMobile: boolean = useIsMobile();
</script>

<template>
  <section :class="['faq', { _mobile: isMobile }]" data-testid="faq-section">
    <div class="faq__inner">
      <h2 class="faq__title" data-testid="faq-title">Вопросы и ответы</h2>
      <ul id="collapse" ref="collapse" class="faq__collapse">
        <li
          v-for="(question, index) in questions"
          :id="`question${index + 1}`"
          :key="question.id"
          class="faq__collapse-item"
          data-testid="faq-item"
        >
          <Accordion>
            <template #accordion>
              <h3 class="faq__collapse-title" data-testid="faq-question-title">
                {{ question.title }}
              </h3>
            </template>
            <div class="faq__collapse-text" data-testid="faq-answer">
              <div class="faq__collapse-text-inner">
                <span v-html="question.text"></span>
              </div>
            </div>
          </Accordion>
        </li>
      </ul>
    </div>
  </section>
</template>

<style lang="less">
.faq {
  background-color: @color-black-haze;

  &__inner {
    .container-d();

    padding-top: 60px;
    padding-bottom: 89px;
  }

  &__title {
    .title-section();

    text-align: center;
    margin-bottom: @size-x8;
  }

  &__collapse {
    max-width: 860px;
    margin: 0 auto;
  }

  &__collapse-item:not(:last-child) {
    margin-bottom: 15px;
  }

  &__collapse-title {
    font-size: @size-x6;
    line-height: 25px;
    font-weight: 600;
  }

  &__collapse-text {
    padding: 66px 78px 66px 70px;
  }

  &__collapse-text-inner {
    font-size: 14px;
    line-height: 21px;
    font-weight: 500;
  }

  &._mobile &__inner {
    .container-m();

    padding-top: @size-x10;
    padding-bottom: @size-x10;
  }

  &._mobile &__title {
    font-size: @size-x6;
    font-weight: 700;
    line-height: 25px;
  }

  &._mobile &__collapse-title {
    font-size: @size-x3;
    line-height: @size-x4;
  }

  &._mobile &__collapse-text {
    padding: 27px 17px 37px @size-x7;
  }

  &._mobile &__collapse-text-inner {
    font-size: @size-x3;
    line-height: @size-x4;
  }

  &._mobile &__collapse-item:not(:last-child) {
    margin-bottom: @size-x6;
  }
}
</style>
